module.exports = __webpack_public_path__ + "img/gsb23.d7a9615e.png";